import { ResponsiveKanbanBoard } from '@/components/kanban/ResponsiveKanbanBoard';

export const ClientKanban = () => {
  return (
    <ResponsiveKanbanBoard />
  );
};